import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/contexts/AuthContext";
import { Boxes } from "lucide-react";

export default function Inventory() {
  const { user } = useAuth();
  const [rows, setRows] = useState([]);
  const [branches, setBranches] = useState([]);
  const [loc, setLoc] = useState("");

  useEffect(() => {
    api.get("/branches").then(({ data }) => setBranches(data));
  }, []);

  useEffect(() => {
    const q = loc ? `?location=${loc}` : "";
    api.get(`/inventory${q}`).then(({ data }) => setRows(data));
  }, [loc]);

  const locOptions = [
    { value: "", label: user?.role === "admin" ? "Semua Lokasi" : "Otomatis" },
    { value: "gudang", label: "Gudang Pusat" },
    ...branches.map((b) => ({ value: b.id, label: `${b.name} - ${b.city}` })),
  ];

  const locName = (l) => l === "gudang" ? "Gudang Pusat" : (branches.find(b => b.id === l)?.name || l);

  return (
    <div className="space-y-5">
      <div>
        <p className="text-xs uppercase tracking-widest text-blue-600 font-bold">Stok Real-time</p>
        <h1 className="text-3xl font-extrabold text-slate-900" style={{fontFamily:'Manrope'}}>Inventaris</h1>
      </div>

      {user?.role === "admin" && (
        <select data-testid="inv-filter" value={loc} onChange={(e) => setLoc(e.target.value)} className="w-full sm:w-72 h-12 px-4 rounded-lg border border-slate-300 bg-white text-base">
          {locOptions.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      )}

      <div className="bg-white rounded-xl border border-slate-200 overflow-hidden">
        <table className="w-full text-sm">
          <thead className="bg-slate-50 text-slate-600 text-xs uppercase tracking-wider">
            <tr>
              <th className="text-left px-4 py-3 font-bold">Produk</th>
              <th className="text-left px-4 py-3 font-bold hidden sm:table-cell">SKU</th>
              <th className="text-left px-4 py-3 font-bold hidden md:table-cell">Lokasi</th>
              <th className="text-right px-4 py-3 font-bold">Qty</th>
            </tr>
          </thead>
          <tbody>
            {rows.length === 0 && (<tr><td colSpan={4} className="px-4 py-8 text-center text-slate-500">Belum ada stok.</td></tr>)}
            {rows.map((r) => (
              <tr key={`${r.location}-${r.product_id}`} className="border-t border-slate-100">
                <td className="px-4 py-3">
                  <p className="font-semibold text-slate-900">{r.product?.name || r.product_id}</p>
                  <p className="text-xs text-slate-500 sm:hidden">{r.product?.sku} · {locName(r.location)}</p>
                </td>
                <td className="px-4 py-3 hidden sm:table-cell font-mono text-slate-600">{r.product?.sku}</td>
                <td className="px-4 py-3 hidden md:table-cell text-slate-600">{locName(r.location)}</td>
                <td className="px-4 py-3 text-right font-bold text-slate-900" style={{fontFamily:'IBM Plex Sans'}}>{r.qty} <span className="text-xs text-slate-500 font-normal">{r.product?.unit}</span></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}
